import React, { Component, Fragment } from 'react';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import ItemDef from './ItemDef';
import authService from '../../services/AuthService';
import api, { apiErrorHandler } from '../../services/AxiosService';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class ItemDefs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            domain: props.domain,
            itemDefs: null
        }

        this.itemDefs = [];
    }

    itemChangeHandler = (itemDefId, domain, assessmentArea, text, desc, displayOrder) => {
        let found = false;
        for (let i = 0; i < this.itemDefs.length; i++) {
            if (this.itemDefs[i].itemDefId == itemDefId) {
                // Found it.  Update the item
                found = true;

                // Null values mean that items was NOT changed during this call and should not be updated
                if (domain != null) {
                    this.itemDefs[i].domainName = domain;
                }
                if (assessmentArea != null) {
                    this.itemDefs[i].assessmentArea = assessmentArea;
                }
                if (text != null) {
                    this.itemDefs[i].text = text;
                }
                if (desc != null) {
                    this.itemDefs[i].description = desc;
                }
                if (displayOrder != null) {
                    this.itemDefs[i].displayOrder = displayOrder;
                }
                break;
            }
        }

        if (!found) {
            this.itemDefs.push({ itemDefId: itemDefId, domainName: domain, assessmentArea: assessmentArea, text: text, description: desc, displayOrder: displayOrder });
        }
        this.props.itemChangeHandler(this.itemDefs);
    }

    componentDidMount = () => {
        /*
         * Run a query to get the item information for the domain specified in props (null is all domains).
         * The query returns a list of definitions. 
         */
        let domainName = (this.state.domain == null || this.state.domain == "") ? "All" : this.state.domain;

        let url = "admin/" + domainName + "/items";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
        .then((response) => {
            if (response.status == 200) {
                // Add one more item as a placeholder for new items
                response.data.items.push({ itemDefId: 0, domainName: "New", assessmentArea: null, text: null, description: null, displayOrder: null});
                this.setState({
                    itemDefs: response.data.items
                });
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login?
            this.setState({ showErrorAlert: true });
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        // Build the table's rows.  
        let items = null;
        if (this.state.itemDefs != null) {
            items = this.state.itemDefs.map((item) => {
                return (
                        <ItemDef
                            itemDefId={item.itemDefId}
                            domainName={item.domainName}
                            assessmentArea={item.assessmentArea}
                            text={item.text}
                            description={item.description}
                            displayOrder={item.displayOrder}
                            changeHandler={this.itemChangeHandler}
                        />
                );
            })
        }
    return(
        <Fragment>
            <Form>
                <Table striped bordered responsive size="sm">
                    <thead>
                        <tr>
                            <th width="170">Domain</th>
                            <th width="250">Assessment Area</th>
                            <th width="600">Text</th>
                            <th width="70">Order</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items}
                    </tbody>
                </Table>
            </Form>
        </Fragment>
        );
    }
}

export default ItemDefs;


// WEBPACK FOOTER //
// ./src/components/AdminHome/ItemDefs.js